import React from 'react'
import { Box, LinearProgress } from '@mui/material'

export interface StatusbarProps {
  loading: boolean
}

const Statusbar: React.FC<StatusbarProps> = ({ loading }) => {
  const [progress, setProgress] = React.useState(10)
  const [visible, setVisible] = React.useState(false)
  const finishingRef = React.useRef(false)

  React.useEffect(() => {
    let timer: NodeJS.Timeout | null = null

    if (loading) {
      setVisible(true)
      setProgress(0)
      finishingRef.current = false
      timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress >= 90) return 90
          const diff = 15 + Math.random() * 10
          return Math.min(oldProgress + diff, 90)
        })
      }, 700)
    } else if (!loading && visible && !finishingRef.current) {
      // When loading becomes false, finish the bar to 100%
      finishingRef.current = true
      timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress >= 100) {
            if (timer) clearInterval(timer)
            setTimeout(() => setVisible(false), 250) // Hide after short delay
            return 100
          }
          return Math.min(oldProgress + 25, 100)
        })
      }, 100)
    }

    return () => {
      if (timer) clearInterval(timer)
    }
  }, [loading, visible])

  if (!visible) return null

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#0275ff',
          },
        }}
      />
    </Box>
  )
}

export { Statusbar }
export default Statusbar 

